import { useGetExtendedUserQuery } from 'generated/graphql';
import { apolloStatusToQueryStatus } from 'v2/core/repository/edge-server/statusConvertor';
import { QueryOptions } from 'v2/core/repository/edge-server/types';
import { useGetUserMaybe } from 'v2/core/services/user';

export interface FetchUserTagsOptions {
  skip?: boolean;
  fetchPolicy?: QueryOptions['FetchPolicy'];
  onCompleted?: () => void;
  onError?: (error: Error) => void;
}

export const useFetchUserTags = (options?: FetchUserTagsOptions) => {
  const user = useGetUserMaybe();

  const { data, loading, error, called } = useGetExtendedUserQuery({
    variables: {
      tenantID: user?.tenant.id ?? '',
      userID: user?.id ?? '',
      tags: true,
    },
    fetchPolicy: options?.fetchPolicy ?? 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    skip: Boolean(options?.skip) || !user?.id || !user.tenant.id,
    onCompleted: options?.onCompleted,
    onError: options?.onError,
  });

  const status = apolloStatusToQueryStatus(loading, called, false, error);

  return {
    tags: data?.getExtendedUser?.tags ?? [],
    status,
    error,
  };
};
